import { ChakraText } from '@equip.health/ui';

interface MaiChatEmptyStateProps {
  patientFirstName: string;
}

const MaiChatEmptyState = ({ patientFirstName }: MaiChatEmptyStateProps) => {
  return (
    <ChakraText
      data-testid="mai-chat-empty-state"
      color="neutral.primary"
      fontSize="14px"
      lineHeight="1.5"
    >
      Nothing new since your last visit. Ask me anything about{' '}
      {patientFirstName}&apos;s care.
    </ChakraText>
  );
};

export default MaiChatEmptyState;
